<template>
  <div id="index-exam-prepare">
    <!-- 考试准备界面 -->
    <div class="content" v-loading="loading">
      <h1>{{ data.name }}</h1>
      <h4>
        考试时间: {{ data.examTime }}
        <span>考试时长:{{ data.examDuration }}分钟</span>
      </h4>
      <h4 v-if="flag == '1'">
        距离本场考试还剩:<span style="color: #fd9711"> {{ timeDiff }}</span>
      </h4>
      <div class="add_but" @click="submit">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      examId: "",
      data: {
        name: "",
        examTime: "2023-6-13 12:00:00",
        examDuration: "",
      },
      flag: "1", // 0 考试中  1 未开始  2 已结束  3 已交卷
      text: "开始考试",
      residueTime: "9天",
      timeDiff: "",
      timer: null,
    };
  },
  methods: {
    /**
     * 获取当前考试的基本信息
     */
    async showExamDetails() {
      this.loading = true;
      try {
        let resultData = await this.$request({
          url: "/exam/showExamDetails",
          method: "post",
          data: { id: this.examId },
        });
        this.data = resultData;
        // 计算考试开始时间距离今天的天数
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 获取当前学员对当前考试的状态
     */
    async getExamStatusByUser() {
      try {
        let resultData = await this.$request({
          url: "/studentExam/getExamStatusByUser",
          method: "post",
          data: { examId: this.examId },
        });
        this.flag = resultData.flag;
        switch (this.flag) {
          case "0":
            this.text = "开始考试";
            break;
          case "1":
            this.text = "考试暂未开始请耐心等待!";
            break;
          case "2":
            this.text = "考试已结束! 查看考试详情";
            break;
          case "3":
            this.text = "您已成功交卷! 查看考试详情";
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 按钮操作
     */
    submit() {
      if (this.flag != "1") {
        // 确认信息
        this.$router.push({
          path: "/exam/testing",
          query: {
            id: this.examId,
            flag: this.flag,
          },
        });
      }
    },
    /**
     * 考试倒计时
     */
    intervalTime() {
      const examTime = new Date(this.data.examTime); // 考试开始时间
      const nowTime1 = new Date(); // 当前时间
      const timeDiff1 = Math.abs(nowTime1.getTime() - examTime.getTime());
      const days = Math.ceil(timeDiff1 / (1000 * 3600 * 24));
      let that = this;
      console.log("剩余天数", days);
      if (days == 1) {
        // 考试时间就今天
        this.timer = setInterval(() => {
          console.log("定时器");
          let nowTime = new Date();
          let timeDiff = examTime.getTime() - nowTime.getTime();
          if (timeDiff <= 0) {
            clearInterval(this.timer);
            that.timeDiff = "0 天 0 小时 0 分钟 0 秒";
          } else {
            const hours = Math.floor(timeDiff / (1000 * 60 * 60));
            timeDiff -= hours * (1000 * 60 * 60);
            const minutes = Math.floor(timeDiff / (1000 * 60));
            timeDiff -= minutes * (1000 * 60);
            const seconds = Math.floor(timeDiff / 1000);
            that.timeDiff =
              "0 天" + `${hours} 小时 ${minutes} 分钟 ${seconds} 秒`;
          }
        }, 1000);
      } else {
        this.timeDiff = days + "天";
      }
    },
  },
  async mounted() {
    this.examId = this.$route.query.id;
    await this.showExamDetails();
    await this.getExamStatusByUser();
    if (this.flag == "0") {
      this.intervalTime();
    }
    this.loading = false;
  },
  destoryed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style lang="less" scoped>
#index-exam-prepare {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .content {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    align-items: center;
    // justify-content: center;
    h1 {
      margin-top: 180px;
      margin-bottom: 50px;
    }
    h4 {
      margin-bottom: 50px;
      > span {
        margin-left: 20px;
      }
    }
  }
}
</style>